import React from 'react'
import dataLayer from '../../helpers/functions/dataLayer'
import styles from './phoneNumber.module.scss'

const pushDataLayer = () => dataLayer.push({ event: 'call', action: 'click' })

interface Props {
  telephone?: string
  location?: string
  countryCode?: string
}

export default function PhoneNumberLink({
  telephone,
  location,
  countryCode,
}: Props) {
  const href = countryCode
    ? `https://wa.me/${countryCode}${telephone.replace(/\s/g, '')}`
    : `tel:${telephone}`
  return (
    <React.Fragment>
      {location && <span className={styles.telDesktop}>{location}</span>}
      <a href={href} onClick={pushDataLayer} className={styles.linkMobile}>
        {telephone}
      </a>
    </React.Fragment>
  )
}
